import axios from 'axios'
import jwtToken from './getJwtToken'
import { errorHandler } from './errorHandler'
import { locale } from './locale'

const RELEASES_API_URL = process.env.VUE_APP_RELEASES_API_URL

const releasesApi = axios.create({
  baseURL: `${RELEASES_API_URL}/api/me`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': locale,
  },
})

releasesApi.interceptors.response.use(
  response => response,
  error => errorHandler(error),
)

releasesApi.interceptors.request.use(
  request => request,
  error => errorHandler(error),
)

export default releasesApi
